import InlineSelectField from './InlineSelectField';
const meta = {
    title: 'Features/Forms/InlineSelectField',
    component: InlineSelectField
};
export default meta;
const dayOfMonth = [
    ['1', 1], ['2', 2], ['3', 3], ['4', 4], ['5', 5],
    ['15', 15], ['28', 28], ['Last day', -1]
];
const weekOfMonth = [
    ['First', 1], ['Second', 2], ['Third', 3], ['Fourth', 4], ['Last', -1]
];
export const Default = {
    args: {
        name: 'frequency_schedule[monthly][day_of_month]',
        options: dayOfMonth,
        initialValue: 15
    }
};
export const WithLabel = {
    args: {
        name: 'frequency_schedule[monthly][day_of_month]',
        options: dayOfMonth,
        initialValue: 15,
        label: 'Day'
    }
};
export const TupleAndObjectOptions = {
    args: {
        name: 'frequency_schedule[monthly][week_of_month]',
        options: weekOfMonth,
        initialValue: 1,
        label: 'The'
    }
};
export const Disabled = {
    args: {
        name: 'frequency_schedule[monthly][day_of_month]',
        options: dayOfMonth,
        initialValue: 1,
        label: 'Day',
        disabled: true
    }
};
